module.exports = __webpack_public_path__ + "static/img/bb5ee6684de19015db37ffe7ba48bfbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ck_white.png
// module id = UZcy
// module chunks = 1